// Configuration object for header search events
export const headerSearchEventsConfig = {
    parentSelector: '.header', // Default parent for header elements
    events: {
        // Search Modal Open/Close
        searchModal: {
            selector: 'details-modal.header__search', // Selector for the details element containing the modal
            events: {
                open: {
                    selector: '.modal__toggle', // Target the summary/button that opens it
                    event: 'search',
                    component: 'search_modal',
                    element: 'modal',
                    action: 'open',
                    trigger: 'click'
                },
                close: {
                    selector: '.search-modal__close-button', 
                    event: 'search',
                    component: 'search_modal',
                    element: 'modal',
                    action: 'close',
                    trigger: 'click'
                }
            }
        },
        // Search Input Field within Header Modal
        searchField: {
            parentSelector: '.header__search .search-modal__form', // Specific parent within header modal
            selector: '.search__input',
            events: {
                focus: {
                    event: 'search',
                    component: 'header', // Should still be header context
                    element: 'text_field',
                    action: 'focus',
                    trigger: 'focus'
                },
                input: {
                    event: 'search',
                    component: 'header',
                    element: 'text_field',
                    action: 'input',
                    trigger: 'input',
                    getDynamicData: (element) => ({
                        action_value: element.value
                    })
                },
                submit: { // Submit via Enter key in header modal
                    event: 'search',
                    component: 'header',
                    element: 'text_field',
                    action: 'submit',
                    trigger: 'submit',
                    getDynamicData: (element) => ({
                        action_value: element.value,
                        link_url: `/search?q=${encodeURIComponent(element.value)}`
                    })
                }
            }
        },
        // Clear Icon Click within Header Modal
        searchFieldClear: {
            parentSelector: '.header__search .search-modal__form', // Specific parent
            selector: '.reset__button svg.icon.icon-close', // Selector for the clear icon
            event: {
                event: 'search',
                component: 'header',
                element: 'icon',
                action: 'click',
                trigger: 'click',
                getDynamicData: () => ({
                    action_value: 'remove'
                })
            }
        },
        // Search Icon Click within Header Modal
        searchIconClick: {
            parentSelector: '.header__search .search-modal__form', // Specific parent
            selector: 'button.search__button svg.icon.icon-search', 
            event: {
                event: 'search',
                component: 'header', // Correct component
                element: 'icon',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => {
                    const inputElement = element.closest('form.search')?.querySelector('.search__input');
                    const searchTerm = inputElement ? inputElement.value : '';
                    return {
                        action_value: searchTerm,
                        link_url: `/search?q=${encodeURIComponent(searchTerm)}`
                    };
                }
            }
        },
        // Click on Predictive Search Results Links in Header
        headerSearchResultsClick: {
            parentSelector: '.header__search .predictive-search', // Specific parent
            selector: 'a.predictive-search__item, a.predictive-search__item *',
            event: {
                event: 'search',
                component: 'header',
                element: 'link',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => {
                    const anchorElement = element.closest('a.predictive-search__item');
                    if (!anchorElement) return null; 
                    
                    let fieldName = 'link'; 
                    const parentList = anchorElement.closest('ul.predictive-search__results-list');
                    
                    if (parentList && parentList.id) {
                        if (parentList.id.includes('-queries-list')) {
                            if (anchorElement.href.includes('/collections/')) {
                                fieldName = 'collections';
                            } else {
                                fieldName = 'suggestions';
                            }
                        } else if (parentList.id.includes('-products-list')) {
                            fieldName = 'products';
                        } else if (parentList.id.includes('-pages-list')) {
                            fieldName = 'pages';
                        }
                    }
                    
                    const contentElement = anchorElement.querySelector('.predictive-search__item-heading');
                    const linkText = contentElement ? contentElement.textContent.trim() : anchorElement.textContent.trim();

                    return {
                        field_name: fieldName,
                        link_text: linkText,
                        link_url: anchorElement.href
                    };
                }
            }
        }
    }
}; 